module.exports = __webpack_public_path__ + "static/media/empty_image.8da513ed.svg";